export enum ScreenSizeCategoryEnum {
    XS = 'ExtraSmall',
    SM = 'Small',
    MD = 'Medium',
    LG = 'Large',
    XL = 'ExtraLarge'
}